import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import WorkOrderTable from '../WorkOrderTable';
import { EmptyState } from '../empty_state/EmptyState';
import {
	BUYER_WO_FILTERS_ORDER,
	INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER,
	PAYING_SUPPLIER_WO_FILTER_ORDER,
	THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
} from '../../utils/WorkOrderUtils';
import { Alert, Button, message, Modal } from 'antd';
import {
	linkWorkOrderForBuyer,
	linkWorkOrderForSupplier,
	unLinkWorkOrderForBuyer,
	unLinkWorkOrderForSupplier,
	workOrdersRestCrudThunksForBuyer,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	refreshCounts,
	workOrderSearchAndAPIAdaptor,
} from '../../thunks/work_orders_thunks_wrapper';
import WorkOrderCreateButton from '../common/WorkOrderCreateButton';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import {
	compareStrings,
	getEntityById,
	getWorkOrderTimeZoneId,
	isAdminUser,
	isSupplierPayingCustomer,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import NoAddWorkOrderHeader from '../WorkOrderTable/TableHeader/noAddWorkOrderHeader';
import './index.less';
import {
	areasRestCrudThunksForBuyer,
	areasRestCrudThunksForSupplier,
} from '../../thunks/areas_thunks';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import { getAreaHierarchyChain } from '../../utils/AreaUtils';
import { getProblemTypeHierarchyChain } from '../../utils/ProblemTypesUtils';
import { isBuyerOrInternalTech, isInternalTech, PERMISSION_NAMES } from '../../utils/AuthUtils';
import DateTimeHover from '../date_time_component/DateTime';
import { UserName } from '../name_component/user/UserNameComponent';
import WorkOrderTableRowBuyer from '../WorkOrderTable/WorkOrderTableRow/buyer';
import WorkOrderTableRowSupplier from '../WorkOrderTable/WorkOrderTableRow/supplier';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import OWButton from '../ow_button/OWButton';

const CustomHeaderComponentForLinkedWorkOrders = ({
	selectedUnLinkRowKeys,
	isBuyerAdmin,
	onSubmit,
	showLinkCTA,
	setLinkWoModalVisible,
	newWOParams,
	currentWorkOrderId,
	...props
}) => {
	return (
		<NoAddWorkOrderHeader
			{...props}
			rightActions={
				<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LINKING_WORK_ORDERS}>
					{selectedUnLinkRowKeys.length && isBuyerAdmin ? (
						<Button type="default" onClick={() => onSubmit(FORMTYPE.UNLINK, selectedUnLinkRowKeys)}>
							Unlink Selected Work Orders ({selectedUnLinkRowKeys.length})
						</Button>
					) : null}
					{showLinkCTA ? (
						<Button type="default" onClick={() => setLinkWoModalVisible(true)}>
							Link Work Order
						</Button>
					) : null}
					<WorkOrderCreateButton
						align="center"
						size="default"
						backText="Back to WorkOrders"
						title="Create Linked Work Order"
						getLink={(location, BACK_TEXT, path) => {
							const paramsString = new URLSearchParams(newWOParams).toString();
							return getLinkWIthBackLinkParams(location, BACK_TEXT, `${path}?${paramsString}`);
						}}
					/>
				</AccessPermissionChecker>
			}
			key={currentWorkOrderId}
		/>
	);
};

const FORM_ID = 'wo-link-work-orders-form';
const FORMTYPE = {
	LINK: 'Link',
	UNLINK: 'Unlink',
};

const TC_NAME = 'linkedWorkOrders';

function LinkedWorkOrders({
	match,
	currentWorkOrder,
	linkWorkOrders,
	unlinkWorkOrders,
	getWorkOrder,
	fetchWorkOrders,
	workOrders,
	WOrefreshCounts,
	fetchAreas,
	fetchProblemTypes,
	userType,
	currentUser,
	companyConfig,
	location,
}) {
	const currentWorkOrderId = match.params.id;

	const [linkWoModalVisible, setLinkWoModalVisible] = useState(false);

	const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
	const [selectedUnLinkRowKeys, setSelectedUnlinkRowKeys] = React.useState<React.Key[]>([]);
	const [loading, setLoading] = useState(false);
	const [newWOParams, setNewWOParams] = useState({});

	const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};
	const onSelectUnlinkChange = (newSelectedRowKeys: React.Key[]) => {
		setSelectedUnlinkRowKeys(newSelectedRowKeys);
	};

	const isBuyerAdmin = userType === ROLE_TYPES.BUYER && isAdminUser(currentUser);

	useEffect(() => {
		prepareCreateNewWorkOrder();
	}, [currentWorkOrderId]);

	const LinkedWorkOrderRow = ({ record, simplify = false }) => {
		// Table records come from the search index, where linkedToWorkOrders is a bare id
		// array with no link metadata. Both sides of a link share the same linkedBy /
		// linkedByContact / linkedAt, so read them from the current work order, which the
		// detail page already fetched fully hydrated.
		const currentlinkedWOObj = nullSafeGetOrElse('linkedToWorkOrders', currentWorkOrder, []).find(
			(item) => nullSafeGet('workOrderId', item) == record.id
		);

		const actions = [];
		if (nullSafeGet('linkedByContact', currentlinkedWOObj)) {
			actions.push(
				<div className=" flex flex-col items-center " style={{ width: 200 }}>
					{/* whoever can link can unlink — same role + permission gate as the Link CTAs */}
					<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LINKING_WORK_ORDERS}>
						<Button
							disabled={!showLinkCTA}
							type="ghost"
							loading={loading}
							onClick={() => {
								onSubmit(FORMTYPE.UNLINK, [record.id]);
							}}
						>
							Unlink
						</Button>
					</AccessPermissionChecker>
					<div className="ml-6  mt-2 flex flex-col justify-center text-gray-400">
						Linked By{' '}
						<UserName
							mode="inline"
							contact={currentlinkedWOObj.linkedByContact}
							extraDetails={[
								{
									key: 'linkedAt',
									display: 'Linked',
									value: (
										<DateTimeHover
											timestamp={currentlinkedWOObj.linkedAt}
											timeZone={getWorkOrderTimeZoneId(currentWorkOrder)}
										/>
									),
								},
							]}
						/>
					</div>
				</div>
			);
		}

		const WorkOrderTableRow =
			userType === ROLE_TYPES.SUPPLIER ? WorkOrderTableRowSupplier : WorkOrderTableRowBuyer;

		return (
			<WorkOrderTableRow
				record={record}
				currentUser={currentUser}
				companyConfig={companyConfig}
				location={{ pathname: location.pathname, search: '' }}
				actions={actions}
				backText="Back to Work Order"
				simplify={simplify}
			/>
		);
	};

	const rowSelection = React.useMemo(
		() => ({
			selectedRowKeys,
			onChange: onSelectChange,
			getCheckboxProps: (record) => ({
				disabled: [
					nullSafeGet('id', currentWorkOrder),
					...nullSafeGetOrElse('linkedToWorkOrders', currentWorkOrder, []).map(
						(i) => i.workOrderId
					),
				].includes(record.id),
			}),
		}),
		[selectedRowKeys, currentWorkOrder]
	);
	const rowUnlinkSelection = React.useMemo(
		() => ({
			selectedUnLinkRowKeys,
			onChange: onSelectUnlinkChange,
		}),
		[selectedUnLinkRowKeys]
	);

	const getStateSliceProp = useCallback(
		(propName) => nullSafeGetOrElse(`${TC_NAME}.${propName}`, workOrders, {}),
		[workOrders]
	);

	const refreshWorkOrderTable = useCallback(() => {
		fetchWorkOrders(
			{},
			TC_NAME,
			getStateSliceProp('pagination'),
			getStateSliceProp('sorting'),
			getStateSliceProp('filters')
		);
		WOrefreshCounts(TC_NAME, getStateSliceProp('filters'));
	}, [fetchWorkOrders, getStateSliceProp, WOrefreshCounts]);

	const onSubmit = useCallback(
		(formType, ids) => {
			const handleWorkOrderLinking = (action) => {
				setLoading(true);
				action(currentWorkOrderId, ids, true)
					.catch(() => {
						message.error(`Failed to ${formType.toLowerCase()} Work Orders`);
					})
					.finally(() => {
						setLoading(false);
						setSelectedRowKeys([]);
						setSelectedUnlinkRowKeys([]);
						getWorkOrder(currentWorkOrderId);
						setLinkWoModalVisible(false);
						refreshWorkOrderTable();
					});
			};

			if (compareStrings(formType, FORMTYPE.LINK)) {
				handleWorkOrderLinking(linkWorkOrders);
			} else if (compareStrings(formType, FORMTYPE.UNLINK)) {
				handleWorkOrderLinking(unlinkWorkOrders);
			}
		},
		[currentWorkOrderId, linkWorkOrders, unlinkWorkOrders, getWorkOrder, refreshWorkOrderTable]
	);

	const prepareCreateNewWorkOrder = () => {
		const promises = [
			fetchAreas(
				{
					locationId: currentWorkOrder.locationId,
					...(nullSafeGet('location.locationTypeId', currentWorkOrder) && {
						locationTypeId: nullSafeGet('location.locationTypeId', currentWorkOrder),
					}),
				},
				'areas',
				{},
				{},
				{}
			),
			fetchProblemTypes({}, 'problemTypes', {}, {}, {}),
		];
		Promise.all(promises).then((data) => {
			const [areas, problemTypes] = data;
			const areaHeirarchy = getAreaHierarchyChain(areas, currentWorkOrder.areaId);
			const areasTier = ['areasTopLevel', 'areaId', 'areaIdNextLevel'];
			const areaIds = {};
			areaHeirarchy.map((area, index) => {
				areaIds[areasTier[index]] = area.id;
			});

			const problemTypeHeirarchy = getProblemTypeHierarchyChain(
				problemTypes,
				currentWorkOrder.problemTypeId
			);

			const problemTypesTier = ['problemTypeTopLevel', 'problemTypeId', 'problemTypeIdNextLevel'];
			const problemTypeIds = {};
			problemTypeHeirarchy.map((problemType, index) => {
				problemTypeIds[problemTypesTier[index]] = problemType;
			});
			const params = {
				locationId: currentWorkOrder.locationId,
				images: currentWorkOrder.images || [],
				linkedWorkOrderId: currentWorkOrder.id,
				...areaIds,
				...problemTypeIds,
				assetId: currentWorkOrder.assetId,
				isAssetDown: currentWorkOrder.isAssetDown,
				supplierFacilityId: currentWorkOrder.supplierFacilityId,
				submittedByName: currentWorkOrder.submittedByName,
			};

			const filteredParams = Object.fromEntries(
				Object.entries(params).filter(([_, value]) => value !== undefined && value !== null)
			);

			setNewWOParams(filteredParams);
		});
	};
	const filters = useMemo(() => {
		if (userType === ROLE_TYPES.BUYER) {
			return BUYER_WO_FILTERS_ORDER;
		} else {
			return isInternalTech(currentUser)
				? INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER
				: isSupplierPayingCustomer(currentUser)
				? PAYING_SUPPLIER_WO_FILTER_ORDER
				: THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER;
		}
	}, [userType, currentUser]);
	const showLinkCTA = useMemo(() => {
		return isBuyerOrInternalTech(currentUser);
	}, [currentUser]);

	const initialFilters = useMemo(() => {
		const filters: any = {};
		filters.locationIds = [currentWorkOrder.locationId];
		if (ROLE_TYPES.BUYER === userType) {
			if (currentWorkOrder.supplierFacilityId) {
				filters.supplierFacilityIds = [currentWorkOrder.supplierFacilityId];
			}
			return filters;
		}
	}, [userType, currentWorkOrder.locationId, currentWorkOrder.supplierFacilityId]);

	const preAppliedFilters = useMemo(() => {
		const filters: any = {};
		if (ROLE_TYPES.SUPPLIER === userType) {
			filters.buyerCompanyId = currentWorkOrder.buyerCompanyId;
		}
		return filters;
	}, [userType, currentWorkOrder.buyerCompanyId]);

	return (
		<AccessPermissionChecker name={PERMISSION_NAMES.VIEW_LINKED_WORK_ORDERS} isPage>
			<WorkOrderTable
				CustomHeaderProps={{
					selectedUnLinkRowKeys,
					isBuyerAdmin,
					onSubmit,
					showLinkCTA,
					setLinkWoModalVisible,
					newWOParams,
					currentWorkOrderId,
				}}
				CustomWorkOrderRowDisplay={LinkedWorkOrderRow}
				CustomHeader={CustomHeaderComponentForLinkedWorkOrders}
				preAppliedFilters={{ baseLinkedWorkOrderId: currentWorkOrderId }}
				filterConfig={{
					filters,
				}}
				renderEmptyState={(currentUser) => (
					<EmptyState
						headline="No linked Work Orders"
						body={
							<div>
								<p>There are no linked Work Orders available for this Work Order.</p>
								{showLinkCTA ? (
									<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LINKING_WORK_ORDERS}>
										<Button type="default" onClick={() => setLinkWoModalVisible(true)}>
											Link Work Order
										</Button>
									</AccessPermissionChecker>
								) : null}
							</div>
						}
					/>
				)}
				targetCollectionName="linkedWorkOrders"
				rowSelection={isBuyerAdmin ? rowUnlinkSelection : null}
				key="linkedWorkOrders"
			/>
			{linkWoModalVisible ? (
				<Modal
					width="80%"
					visible
					title={'Link Work Orders'}
					closable
					onCancel={() => setLinkWoModalVisible(false)}
					forceRender
					footer={
						<>
							<Button onClick={() => setLinkWoModalVisible(false)}>Cancel</Button>
							<OWButton
								type="primary"
								loading={loading}
								disabled={!selectedRowKeys.length}
								onClick={() => onSubmit(FORMTYPE.LINK, selectedRowKeys)}
							>
								Link{selectedRowKeys.length ? ` (${selectedRowKeys.length})` : ''}
							</OWButton>
						</>
					}
					wrapClassName="linked-work-orders-modal"
				>
					<div className="mt-4">
						{nullSafeGet('linkedToWorkOrders.length', currentWorkOrder) ? (
							<Alert
								message={`${nullSafeGet(
									'linkedToWorkOrders.length',
									currentWorkOrder
								)} Work Order(s) linked`}
								description={nullSafeGet('linkedToWorkOrders', currentWorkOrder)
									.map((i) => `WO #${i.workOrderId || ''}`)
									.join(', ')}
								type="info"
							/>
						) : null}
					</div>
					<WorkOrderTable
						CustomWorkOrderRowDisplay={LinkedWorkOrderRow}
						CustomWorkOrderRowDisplayProps={{ simplify: true }}
						key="linkedWorkOrdersModal"
						preAppliedFilters={preAppliedFilters}
						filterConfig={{
							filters,
						}}
						initialFilters={initialFilters}
						renderEmptyState={(currentUser) => <EmptyState headline="No Work Orders" />}
						rowSelection={rowSelection}
						targetCollectionName="linkedWorkOrdersModal"
						CustomHeader={NoAddWorkOrderHeader}
					/>
				</Modal>
			) : null}
		</AccessPermissionChecker>
	);
}

const mapStateToProps = (state, ownProps) => ({
	workOrders: state.work_orders,
	currentWorkOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchMultipleWorkOrders: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: workOrdersRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchWorkOrders: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.searchAndHydrate(
						{ ...params },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection,
						workOrderSearchAndAPIAdaptor
				  )
				: workOrdersRestCrudThunksForBuyer.searchAndHydrate(
						{ ...params },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection,
						workOrderSearchAndAPIAdaptor
				  )
		),
	linkWorkOrders: (baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? linkWorkOrderForSupplier(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
				: linkWorkOrderForBuyer(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
		),
	unlinkWorkOrders: (baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? unLinkWorkOrderForSupplier(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
				: unLinkWorkOrderForBuyer(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
		),
	getWorkOrder: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.readOne(id)
				: workOrdersRestCrudThunksForBuyer.readOne(id)
		),
	WOrefreshCounts: (targetCollectionName, filters) =>
		dispatch(refreshCounts(ownProps.userType)(targetCollectionName, filters)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? areasRestCrudThunksForSupplier.readLite(
						{ ...params, no_pagination: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: areasRestCrudThunksForBuyer.readLite(
						{ ...params, no_pagination: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier
				: problemTypesHeirarchicalForBuyer;
		return dispatch(
			fnToCall(params, targetCollectionName, pagination, sorting, filters, addToTargetCollection)
		);
	},
});

const ComponentWithoutUserType = connect(mapStateToProps, mapDispatchToProps)(LinkedWorkOrders);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
